import { SPECIALITY_TYPES } from '@modules/admin/speciality/constants'

export const getLanguageName = (isoCode) => {
  const LANGUAGES_MAP = {
    es: 'Español',
    en: 'English',
    it: 'Italiano',
    pt: 'Português',
    tr: 'Türk',
    ca: 'Català',
    ar: 'عرب',
  }
  return LANGUAGES_MAP[isoCode]
}
export const createSpecialityRequestBody = (values) => {
  let objectTranslations
  values.translations.forEach((trans) => (objectTranslations = { ...objectTranslations, [trans.locale]: trans }))
  const requestBody = {
    ...values,
    translations: objectTranslations,
    type: values?.type?.id,
  }
  return requestBody
}
export const formatSpecialityType = (type) => SPECIALITY_TYPES.find((el) => el.id === type)
export const getNameSpecialityFromType = (type) => formatSpecialityType(type)?.name
